module.exports = __webpack_public_path__ + "img/exclamation-icon.b7f711f2.svg";